


























































import { computed, defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import TopSection from '~/components/pages/Top/TopSection.vue';
import AppArchiveCard from '~/components/partials/App/AppArchiveCard.vue';
import AppContentGrid from '~/components/partials/App/AppContentGrid.vue';
import ProducingAreaFlag from '~/components/partials/ProducingArea/ProducingAreaFlag.vue';
import { ARCHIVES_LOCALES_MENU } from '~/constants';
import { url } from '~/utils';
import { TopSimpleContentCard } from '~/types/modules/top';

export default defineComponent({
  components: {
    AppArchiveCard,
    AppContentGrid,
    TopSection,
    ProducingAreaFlag,
  },
  props: {
    featuresByLocale: {
      type: Array as PropType<TopSimpleContentCard[][]>,
      required: true,
    },
    activeTabIndex: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const activePartsName = ref(ARCHIVES_LOCALES_MENU[props.activeTabIndex].topParts);

    const activeLocale = computed(() =>
      ARCHIVES_LOCALES_MENU.find(({ topParts }) => topParts === activePartsName.value)
    );

    const activeFeatures = computed(() => {
      const index = ARCHIVES_LOCALES_MENU.findIndex(({ topParts }) => activePartsName.value === topParts);

      return props.featuresByLocale[index] || [];
    });

    const gaPartsType = computed(() => {
      switch (activeLocale.value?.topParts) {
        case 'parts.bordeaux_feature':
          return '産地特集(ボルドー)';
        case 'parts.bourgogne_feature':
          return '産地特集(ブルゴーニュ)';
        case 'parts.champagne_feature':
          return '産地特集(シャンパーニュ)';
        case 'parts.france_feature':
          return '産地特集(その他フランス)';
        case 'parts.italy_feature':
          return '産地特集(イタリア)';
        case 'parts.california_feature':
          return '産地特集(カリフォルニア)';
        case 'parts.japan_feature':
          return '産地特集(日本)';
        case 'parts.other_countries_feature':
          return '産地特集(その他国・地域)';
        default:
          return null;
      }
    });

    const setTabIndex = (index: number) => {
      activePartsName.value = ARCHIVES_LOCALES_MENU[index].topParts;
      emit('set-active-tab-index', index);
    };

    return {
      ARCHIVES_LOCALES_MENU,
      url,
      activePartsName,
      activeLocale,
      activeFeatures,
      gaPartsType,
      setTabIndex,
    };
  },
});
